export default __webpack_public_path__ + "static/media/05.f388f5b2.svg";